/* TerraLife — pastille « Le matériel de ce guide » (téléphone), voir
   snippets/terralife-article-rail.liquid. Visible une fois la rangée de l'article passée,
   cachée quand le bloc complet de fin d'article est à l'écran ; un toucher y mène. */
(() => {
  const rail = document.querySelector('[data-tl-rail]');
  const block = document.querySelector('.tl-artprod-section');
  if (!rail || !block || window.matchMedia('(min-width: 750px)').matches) return;

  const bar = document.querySelector('mobile-navigation-bar');
  if (bar) document.documentElement.style.setProperty('--tl-navbar-h', `${bar.offsetHeight}px`);

  const pill = document.createElement('button');
  pill.type = 'button';
  pill.className = 'tl-rail-pill';
  pill.textContent = 'Le matériel de ce guide ↓';
  pill.addEventListener('click', () => block.scrollIntoView({ behavior: 'smooth', block: 'start' }));
  document.body.appendChild(pill);

  let railPassed = false;
  let blockSeen = false;
  const update = () => pill.classList.toggle('is-on', railPassed && !blockSeen);
  new IntersectionObserver(([e]) => {
    railPassed = !e.isIntersecting && e.boundingClientRect.top < 0;
    update();
  }).observe(rail);
  new IntersectionObserver(([e]) => {
    blockSeen = e.isIntersecting || e.boundingClientRect.top < 0;
    update();
  }).observe(block);
})();
